module.exports = __webpack_public_path__ + "static/img/theme_4.0450f186.png";